import { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spinner, Button } from 'react-bootstrap';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const HOME_URL = 'https://fr.licorne-academy.com';

const SuccessStripe = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [ok, setOk] = useState(false);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');

    const verifyPayment = async () => {
      if (!sessionId) {
        setMessage(
          t('payment_failed_message') || 'Transaction verification failed'
        );
        setOk(false);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`/api/success?session_id=${sessionId}`);
        setMessage(response.data.message || t('paysucc'));
        setOk(
          String(response.data.message || '')
            .toLowerCase()
            .includes('success')
        );
      } catch {
        setMessage(
          t('payment_failed_message') || 'Transaction verification failed'
        );
        setOk(false);
      } finally {
        setLoading(false);
      }
    };

    verifyPayment();

    const timer = setTimeout(() => {
      window.location.href = HOME_URL;
    }, 10000);

    return () => clearTimeout(timer);
  }, [searchParams, t]);

  return (
    <div className='payment-status-page'>
      <div className={`status-panel ${ok ? 'success' : 'fail'}`}>
        <img src='/licorne.png' alt='Licorne' className='status-brand-logo' />
        {loading ? (
          <>
            <Spinner animation='border' className='status-spinner' />
            <p className='status-redirect mt-3'>
              {t('redirecting') || 'Vérification...'}
            </p>
          </>
        ) : (
          <>
            <div className={`status-icon ${ok ? 'success-icon' : 'fail-icon'}`}>
              {ok ? <FaCheckCircle /> : <FaTimesCircle />}
            </div>
            <h1>{ok ? t('paysucc') : t('payfail')}</h1>
            <p>{message}</p>
            <p className='status-redirect'>
              {t('redirecting') || 'Redirection en cours...'}
            </p>
            <div className='status-actions'>
              <Button
                className='btn-teal'
                onClick={() => (window.location.href = HOME_URL)}
              >
                {t('redirect_now') || 'Rediriger maintenant'}
              </Button>
              <Link to='/' className='btn btn-outline-teal'>
                {t('return')}
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SuccessStripe;
